import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../redux/hooks";

import {
  clearAwbHistory,
  clearBinHistory,
  clearWorkingRoutesNodes,
} from "../../../../redux/reducer/expedition.reducer";
import {
  getWorkingRoutesNodes,
  getAwbStatuses,
} from "../../../../redux/api/expedition.api";

import CustomButton from "../../../../components/CustomButton";
import ContentCard from "../../../../components/misc/ContentCard";

import BinTable from "./BinTable";
import AwbTable from "./AwbTable";

function ClientAwbHistory() {
  const dispatch = useAppDispatch();

  const [selectedType, setSelectedType] = useState<"awb" | "bin">("awb");

  useEffect(() => {
    dispatch(
      getWorkingRoutesNodes({
        page: 1,
        perPage: 50,
      }),
    );

    dispatch(getAwbStatuses());

    return () => {
      dispatch(clearWorkingRoutesNodes());
      dispatch(clearAwbHistory());
      dispatch(clearBinHistory());
    };
  }, [dispatch]);

  return (
    <>
      <ContentCard cardBodyClassName="d-flex">
        <CustomButton
          variant={selectedType === "awb" ? "contained" : "outlined"}
          style={{ borderEndEndRadius: 0, borderStartEndRadius: 0 }}
          fullWidth
          onClick={() => setSelectedType("awb")}>
          AWB
        </CustomButton>
        <CustomButton
          variant={selectedType === "bin" ? "contained" : "outlined"}
          style={{ borderEndStartRadius: 0, borderStartStartRadius: 0 }}
          fullWidth
          onClick={() => setSelectedType("bin")}>
          BIN
        </CustomButton>
      </ContentCard>
      {selectedType === "awb" && <AwbTable />}

      {selectedType === "bin" && <BinTable />}
    </>
  );
}

export default ClientAwbHistory;
